import { removeNull } from '@/utils/handleData'
import { buildShipmentSignQcodeInfo } from '@/utils/scanQrcode'

export default {
  namespaced: true,
  state: {
    goodsShipmentList: [], // 物资运输单列表
    goodsShipmentInfo: {} // 物资运输单信息
  },
  getters: {},
  actions: {
    // 新增物资运输单信息
    async addGoodsShipment({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/fixed/transportationorderinfo',
          data: data,
          msg: '新增物资运输单信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除物资运输单信息
    async deleteGoodsShipment({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/fixed/transportationorderinfo',
          data: { uid: uid },
          msg: '删除物资运输单信息成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑物资运输单信息
    async editGoodsShipment({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/fixed/transportationorderinfo',
          data: data,
          msg: data.signingType ? '物资运输单签收成功' : '编辑物资运输单成功'
        },
        { root: true }
      )
      return res
    },
    // 获取物资运输单信息列表
    async getGoodsShipmentList({ rootState, commit, dispatch }, data) {
      var queryValues = {
        orgUid: data && data.orgUid ? data.orgUid : rootState.user.orgValue,
        shipmentType:
          data && data.shipmentType
            ? data.shipmentType
            : rootState.queryValues.goodsShipment &&
              rootState.queryValues.goodsShipment.shipmentType
            ? rootState.queryValues.goodsShipment.shipmentType
            : '',
        shipmentStatus:
          data && data.shipmentStatus
            ? data.shipmentStatus
            : rootState.queryValues.goodsShipment &&
              rootState.queryValues.goodsShipment.shipmentStatus
            ? rootState.queryValues.goodsShipment.shipmentStatus
            : '',
        signingType:
          data && data.signingType
            ? data.signingType
            : rootState.queryValues.goodsShipment &&
              rootState.queryValues.goodsShipment.signingType
            ? rootState.queryValues.goodsShipment.signingType
            : '',
        startTime:
          data && data.startTime
            ? data.startTime
            : rootState.queryValues.goodsShipment &&
              rootState.queryValues.goodsShipment.period
            ? rootState.queryValues.goodsShipment.period[0]
            : '',
        endTime:
          data && data.endTime
            ? data.endTime
            : rootState.queryValues.goodsShipment &&
              rootState.queryValues.goodsShipment.period
            ? rootState.queryValues.goodsShipment.period[1]
            : '',
        query:
          data && data.query
            ? data.query
            : rootState.queryValues.goodsShipment &&
              rootState.queryValues.goodsShipment.query
            ? rootState.queryValues.goodsShipment.query
            : '',
        page: data && data.page ? data.page : rootState.page.goodsShipment,
        limit: data && data.limit ? data.limit : rootState.limit.goodsShipment
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/transportationorderlist',
          data: queryValues
        },
        { root: true }
      )
      var goodsShipmentList = res.data ? res.data : {}
      goodsShipmentList.result.forEach((item) => {
        // 按钮：0查看 1编辑 2发车 3删除 4监控 5二维码
        item.disabledButtons = []
        item.signQcodeInfo = buildShipmentSignQcodeInfo(item)
        item.qcodeInfo = item.signQcodeInfo
        item.monitoring = rootState.officialCar.carList.find((car) => {
          return car.carPlate === item.carCode
        })
        const status = item.shipmentStatus
        if (status === '待装车') {
          // 可编辑/删除；不可发车（须先绑车变为待发车）
          item.disabledButtons.push(2)
        } else if (status === '待发车') {
          // 编辑/发车/删除均可
        } else if (status === '运输中') {
          item.disabledButtons.push(2, 3)
        } else {
          item.disabledButtons.push(1, 2, 3)
        }
        if (!item.monitoring) {
          item.disabledButtons.push(4)
        }
        // 已签收仍可查看签收码；不额外禁用
        // 与浇筑令列表一致：分项名称(部位)
        if (item.orderInfo && item.orderInfo.subitemName) {
          item.workLocation = item.orderInfo.remarks
            ? item.orderInfo.subitemName +
              '(' +
              item.orderInfo.remarks +
              ')'
            : item.orderInfo.subitemName
        } else {
          item.workLocation = item.shipmentType
        }
        item.workType =
          item.orderInfo && item.orderInfo.workType
            ? item.orderInfo.workType
            : ''
        const shipmentType = rootState.dictionarys.shipmentType.find(
          (type) => type.label === item.shipmentType
        )
        item.workName = shipmentType ? shipmentType.workName : null
        item.getWorkInfo = shipmentType ? shipmentType.getWorkInfo : null
        item.getWorkList = shipmentType ? shipmentType.getWorkList : null
        item.workCode =
          shipmentType && item.orderInfo
            ? item.orderInfo[shipmentType.workName + 'Code']
            : ''
        item.workInfo =
          shipmentType && item.orderInfo
            ? shipmentType.workInfoKeys.reduce((per, cur) => {
                return (
                  per +
                  '\xa0\xa0' +
                  (item.orderInfo[cur] ? item.orderInfo[cur] : '')
                )
              }, item.workLocation)
            : item.workLocation
      })
      commit(
        'baseSet',
        {
          module: 'goodsShipment',
          key: 'goodsShipmentList',
          value: goodsShipmentList
        },
        { root: true }
      )
      return goodsShipmentList
    },
    // 获取物资运输单信息
    async getGoodsShipmentInfo({ state, rootState, commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/transportationorderinfo',
          data: { uid: uid ? uid : state.goodsShipmentInfo.uid }
        },
        { root: true }
      )
      var goodsShipmentInfo = res.data ? res.data : {}
      const addr = goodsShipmentInfo.destinationAddress || ''
      const lng = goodsShipmentInfo.destinationLng || ''
      const lat = goodsShipmentInfo.destinationLat || ''
      if (addr || lng) {
        goodsShipmentInfo.destinationDisplay =
          addr && lng && lat
            ? addr + '（' + lng + ',' + lat + '）'
            : addr || lng + (lat ? ',' + lat : '')
      } else {
        goodsShipmentInfo.destinationDisplay = ''
      }
      const shipmentType = rootState.dictionarys.shipmentType.find(
        (item) => item.label === goodsShipmentInfo.shipmentType
      )
      goodsShipmentInfo.workName = shipmentType ? shipmentType.workName : null
      goodsShipmentInfo.getWorkInfo = shipmentType
        ? shipmentType.getWorkInfo
        : null
      goodsShipmentInfo.getWorkList = shipmentType
        ? shipmentType.getWorkList
        : null
      if (
        !goodsShipmentInfo.orderInfo &&
        goodsShipmentInfo.workUid &&
        shipmentType &&
        shipmentType.getWorkInfo
      ) {
        try {
          goodsShipmentInfo.orderInfo = await dispatch(
            shipmentType.getWorkInfo,
            goodsShipmentInfo.workUid,
            { root: true }
          )
        } catch (e) {
          goodsShipmentInfo.orderInfo = null
        }
      }
      if (goodsShipmentInfo.orderInfo) {
        const orderInfo = goodsShipmentInfo.orderInfo
        goodsShipmentInfo.workLocation = orderInfo.subitemName
          ? orderInfo.remarks
            ? orderInfo.subitemName + '(' + orderInfo.remarks + ')'
            : orderInfo.subitemName
          : goodsShipmentInfo.shipmentType
        goodsShipmentInfo.workType = orderInfo.workType
        goodsShipmentInfo.workCode = shipmentType
          ? orderInfo[shipmentType.workName + 'Code']
          : ''
        goodsShipmentInfo.workInfo = (
          shipmentType && shipmentType.workInfoKeys
            ? shipmentType.workInfoKeys
            : []
        ).reduce((per, cur) => {
          return per + ' ' + (orderInfo[cur] ? orderInfo[cur] : '')
        }, goodsShipmentInfo.workLocation)
        // 编辑回显：未完成列表可能不含当前业务单，补一条供下拉选中
        if (shipmentType && shipmentType.workName === 'pouringOrder') {
          const list = rootState.pouringOrder.unfinishedPouringOrderList || []
          const exists = list.some(
            (item) => item.uid === goodsShipmentInfo.workUid
          )
          if (!exists) {
            const option = Object.assign({}, orderInfo, {
              uid: goodsShipmentInfo.workUid,
              value: goodsShipmentInfo.workUid,
              pouringLocation: orderInfo.remarks
                ? (orderInfo.subitemName || '') +
                  '(' +
                  orderInfo.remarks +
                  ')'
                : orderInfo.subitemName,
              label:
                (orderInfo.workType || '') +
                ' ' +
                (orderInfo.pouringOrderCode || '') +
                ' ' +
                (orderInfo.subitemName || '') +
                ' ' +
                (orderInfo.strengthGrade || '')
            })
            commit(
              'baseSet',
              {
                module: 'pouringOrder',
                key: 'unfinishedPouringOrderList',
                value: list.concat([option])
              },
              { root: true }
            )
          }
        }
      } else if (goodsShipmentInfo.workUid) {
        goodsShipmentInfo.workInfo = goodsShipmentInfo.workUid
        goodsShipmentInfo.workLocation = goodsShipmentInfo.shipmentType
      }
      if (goodsShipmentInfo.productionTaskUid) {
        const tasks = await dispatch(
          'mixingProduction/getTasksByOrder',
          goodsShipmentInfo.workUid,
          { root: true }
        )
        const matched = (tasks || []).find(
          (item) => item.uid === goodsShipmentInfo.productionTaskUid
        )
        goodsShipmentInfo.productionTaskCode = matched
          ? matched.taskCode
          : goodsShipmentInfo.productionTaskUid
      } else {
        goodsShipmentInfo.productionTaskCode = ''
      }
      goodsShipmentInfo.signQcodeInfo =
        buildShipmentSignQcodeInfo(goodsShipmentInfo)
      goodsShipmentInfo.qcodeInfo = goodsShipmentInfo.signQcodeInfo
      commit(
        'baseSet',
        {
          module: 'goodsShipment',
          key: 'goodsShipmentInfo',
          value: goodsShipmentInfo
        },
        { root: true }
      )
      return goodsShipmentInfo
    }
  }
}
